import { useQuery } from '@tanstack/react-query';
import { playerQueryOptions } from '@/queries/player/player.queries';
import { useAppSelector } from '@/redux/hooks';
import { isReferralUnlockedStatus } from '../model/utils/isReferralUnlockedStatus';

export const useReferralUnlockState = () => {
  const { userSession, loading: isSessionLoading } = useAppSelector(state => state.user);
  const { data: playerProfile, isPending: isProfilePending } = useQuery(playerQueryOptions.mePlayerProfile({ enabled: !!userSession }));

  return {
    isReferralUnlocked: !!userSession && isReferralUnlockedStatus(playerProfile?.progressStatus?.name),
    isLoading: isSessionLoading || (userSession && isProfilePending),
  };
};

export const useIsReferralUnlocked = (): boolean => useReferralUnlockState().isReferralUnlocked;
